import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { Button } from '@nextui-org/react'
import { ControlledEmailInput } from '@shared/components/controlled-fields'
import { __ } from '@wordpress/i18n'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'

import { submitForm } from '../lib/service'
import { emailRegex } from '../lib/util'

type FormState = {
  email: string
}

const defaultValues: FormState = {
  email: '',
}

function SubscribeForm() {
  const { settings } = useSiteConfiguration()
  const subscription = settings?.subscription

  const {
    control,
    formState: { isSubmitting },
    handleSubmit,
    reset,
  } = useForm<FormState>({
    defaultValues,
    mode: 'onBlur',
  })

  const handleOnSubmit = async (data: FormState) => {
    await toast
      .promise(
        submitForm({
          data,
          formId: 3,
        }),
        {
          error: 'Something went wrong',
          loading: 'Submitting...',
          success: (response) => {
            return response.result.message || 'Subscribed successfully'
          },
        },
      )
      .then(() => {
        reset(defaultValues)
      })
  }

  return (
    <>
      <h4 className="mb-4 text-center font-medium uppercase md:text-left">
        {subscription?.title}
      </h4>
      <div className="relative">
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <ControlledEmailInput
            control={control}
            fieldProps={{
              classNames: {
                input: 'placeholder:uppercase',
                inputWrapper: 'border-primary',
                label: 'uppercase',
              },
              label: __('Email Address', 'asavagroup'),
              type: 'email',
              variant: 'underlined',
            }}
            name="email"
            rules={{
              pattern: {
                message: 'Please enter a valid email address',
                value: emailRegex,
              },
              required: 'Please enter your email address',
            }}
          />
          <Button
            className="absolute inset-y-0 right-0 my-auto"
            color="primary"
            isLoading={isSubmitting}
            type="submit"
            variant="light"
          >
            {__('Subscribe', 'asavagroup')}
          </Button>
        </form>
      </div>
    </>
  )
}

export default SubscribeForm
